import api from "@/utils/backend-api";

const state = {
  account: {}
};

const getters = {
};

const actions = {
  getInfo ({ commit }) {
    api.getData("info/account").then(res => {
        commit("setInfo", res.data);
    });
  },
};

const mutations = {
  setInfo (state, info) {
    state.account = info;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/inform.js